import { max, min } from 'd3-array';
import data from './data/data.json';
import meta from './data/meta.json';
import { bandAxis } from '../../../factory/axes';
import { ordinalScale, linearScale } from '../../../factory/scales';
import { cnn_red } from './utils/colors';

export default function (props) {
  const { initialWidth, initialHeight } = props;

  const labels = {
    start: meta.start_label,
    end: meta.end_label,
  };

  const margins = {
    top: 50,
    right: initialWidth <= 280 ? 105 : 115,
    bottom: initialWidth >= 800 ? 245 : 195,
    left: 25,
  };

  const width = initialWidth - margins.right - margins.left;
  const height = initialHeight - margins.top - margins.bottom;
  const padding = initialWidth <= 500 ? 0.3 : 0.15;

  const xAxisConfig = {
    orientation: 'bottom',
    domain: [labels.start, labels.end],
    range: [0, width],
    padding,
  };

  const { axis: xAxis, scale: x } = bandAxis(xAxisConfig);

  const maxEndValue = max(data, d => d.end);
  const minStartValue = min(data, d => d.start);

  const y = linearScale({
    domain: [maxEndValue, minStartValue],
    range: [height, 0],
  });

  const colorScale = ordinalScale({
    domain: data.map(d => d.label),
    range: cnn_red[5],
  });

  return {
    colorScale,
    data,
    height,
    initialHeight,
    initialWidth,
    margins,
    width,
    x,
    xAxis,
    y,
  };
}
